import React, { ComponentProps, ReactElement, cloneElement } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import {
  CmsApiCmsPageLink,
  CmsApiLinkType,
  CmsApiUrlLink,
} from 'modules/cms/api/types/CmsApiLink';
import { trackClicked } from 'utils/analytics/track/trackClicked';

type Props = {
  buttonData: CmsApiUrlLink | CmsApiCmsPageLink;
  eventProperties: Record<string, unknown>;
  children: ReactElement<ComponentProps<typeof AnchorButton>>;
};

export function CmsLinkButton(props: Props) {
  const { eventProperties, buttonData, children } = props;

  return cloneElement(
    children,
    {
      onClick: () => {
        trackClicked('CMS Block', {
          url: buttonData.data.url,
          ...eventProperties,
        });
      },
      href: buttonData.data.url,
      title:
        buttonData.type === CmsApiLinkType.CMS_PAGE
          ? buttonData.data.pageTitle
          : undefined,
      target: '_blank',
      'data-qa-id': 'cms-button-link',
    },
    <Box display="flex" alignItems="center">
      {buttonData.text}
    </Box>,
  );
}
